<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-calendar-dots'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [percentageDifferenceEnabled]="false"
></app-kpi-widget>